import * as React from 'react';
import { useEffect } from 'react';

/** Material UI Packages. */
import { Avatar, Typography, useMediaQuery } from '@mui/material';

/** Auth0 authenticator Packages. */
import { useAuth0 } from '@auth0/auth0-react';

/** Router packages. */
import { useNavigate } from 'react-router-dom';

/** Internal Components */
import insight_logo from '../statics/images/insight_logo_app.png';
import login from '../statics/images/login.png';
import { PAGE_STYLES, BREAKPOINTS } from '../theme/PageStyles';

import PageLayout from './pageLayout';

export default function LoginPage() {
    /** Destructure necessary properties from Auth0. */
    const { isAuthenticated, user, loginWithRedirect } = useAuth0();

    /** Get the navigation function from React Router. */
    const navigate = useNavigate();

    /** Detecting window size for responsive web. */
    const isMediumScreen = useMediaQuery(`(max-width: ${BREAKPOINTS.SMALL}px)`);

    /** Catch if the user is authenticated and has an active state of permission role.
     * * Redirect authenticated users based on their roles.
     */
    useEffect(() => {
        if (isAuthenticated && user) {
            return navigate('/');
        }
    }, [isAuthenticated, user]);

    const handleLogin = () => {
        loginWithRedirect({
            redirect_uri: window.location.origin,
        });
    };

    const renderLoginContent = () => (
        <>
            <Avatar alt="logo" src={insight_logo} sx={PAGE_STYLES.logo} />
            <Typography sx={{ ...PAGE_STYLES.title, fontSize: '1.8rem' }}>Welcome back!</Typography>
        </>
    );

    return (
        <PageLayout
            backgroundImage={login}
            isMediumScreen={isMediumScreen}
            buttonText="Get Started"
            onButtonClick={handleLogin}
        >
            {renderLoginContent()}
        </PageLayout>
    );
}
